var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[(!_vm.isInit)?_c('div',{staticClass:"text-center my-1"},[_vm._v("Загрузка документа...")]):_vm._e(),_c('div',{attrs:{"id":'richEdit' + _vm.id}}),_c('BtnFullScreen',{attrs:{"value":_vm.fullScreen},on:{"input":_vm.toggleFullScreen}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }